import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

const ProductTypesRowsComponent = (props) => {
  const { rows } = props || {};

  return rows?.map((row) => (
    <TableRow
      key={row.name}
      sx={{
        '&:last-child td, &:last-child th': {
          border: 0,
        },
      }}
    >
      <TableCell component='th' scope='row'>
        {row.product}
      </TableCell>
      <TableCell align='right'>{row.simAutoService}</TableCell>
      <TableCell align='right'>{row.simReco}</TableCell>
      <TableCell align='right'>{row.eSimAutoService}</TableCell>
      <TableCell align='right'>{row.eSimReco}</TableCell>
      <TableCell align='right'>{row.total}</TableCell>
    </TableRow>
  ));
};

export default ProductTypesRowsComponent;
